import announcements from "@/frame/messages/mixins/announcements.js";
import { mapGetters } from "vuex";

export default {
  // eslint-disable-next-line
  data() {
    return {};
  },
  computed: {
    ...mapGetters(["getDetail"])
  },
  mixins: [announcements],
  methods: {
    goToCompanyDash() {
      let auth = this.getUser.pref.select.cauth;
      let page = null;
      if (auth < 6) {
        page = "/companydash";
      } else if (auth === 6) {
        page = "/companydashviewmaintainer";
      } else if (auth === 7) {
        page = "/companydashviewoperator";
      } else if (auth === 8) {
        page = "/companydashviewexternal";
      } else {
        // do nothing
      }
      // go to page
      this.$router.push(page);
    },
    goToCompanyDashSafety() {
      let auth = this.getUser.pref.select.cauth;
      let page = null;
      if (auth < 0) {
        page = "/companydashsafety";
        // go to page
        this.$router.push(page);
      }
    },
    goToCompanyDashTechnical() {
      let auth = this.getUser.pref.select.cauth;
      let page = null;
      if (auth < 0) {
        page = "/companydashtechnical";
        // go to page
        this.$router.push(page);
      }
    },
    goToCompanyDashBusiness() {
      let auth = this.getUser.pref.select.cauth;
      let page = null;
      if (auth < 0) {
        page = "/companydashbusiness";
        // go to page
        this.$router.push(page);
      }
    },
    goToFacilityDash() {
      let auth = this.getUser.pref.select.fauth;
      let page = null;
      if (auth < 6) {
        page = "/facilitydash";
      } else if (auth === 6) {
        page = "/facilitydashviewintegrated";
      } else if (auth === 7) {
        page = "/facilitydashviewcontractor";
      } else if (auth === 8) {
        page = "/facilitydashviewvendor";
      } else {
        // link
      }
      // go to page
      this.$router.push(page);
    },
    goToFacilityEngineering() {
      let auth = this.getUser.pref.select.fauth;
      let page = null;
      if (auth === 8) {
        page = "/facilitydashengineering";
        // go to page
        this.$router.push(page);
      }
    },
    goToFacilityMaintenance() {
      let auth = this.getUser.pref.select.fauth;
      let page = null;
      if (auth > 8) {
        page = "/facilitydashmaintenance";
        // go to page
        this.$router.push(page);
      }
    },
    goToFacilityOperations() {
      let auth = this.getUser.pref.select.fauth;
      let page = null;
      if (auth > 8) {
        page = "/facilitydashoperations";
        // go to page
        this.$router.push(page);
      }
    },
    goToAssetDash() {
      console.log("ASSET DASH");
      // let page = null;
      this.$router.push("/assetdetail");

      // if (this.getDetail !== null && this.getDetail !== undefined) {
      //   if (this.getDetail.basic.tag === "A1") {
      //     page = "/assetdetail";
      //   }
      //   // go to page
      //   this.$router.push(page);
      // }
    }
  }
};
